import logo from './logo';
import subMenu from './subMenu';
import menuItem from './menuItem';
import { mapGetters } from 'vuex';
export default {
  name: 'sideBar',
  components: {
    logo,
    subMenu,
    menuItem
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['baseRoute'])
  }
};